import * as Sentry from "@sentry/browser";

import {
  SENTRY_BROWSER_TRACES_SAMPLE_RATE,
  SENTRY_DSN,
  SENTRY_RELEASE,
} from "@application/config/sentry";

// Strips sign-in tokens from the URL before Sentry.init reads it.
import "./auth_link_token";

// Dashboard paths carry numeric record ids (/dashboard/projects/115/documents/9).
// Collapse them so transactions group per route, not per record.
export const parameterizeTransactionName = (name: string): string =>
  name.replace(/\/\d+(?=\/|$)/g, "/:id");

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    release: SENTRY_RELEASE ?? undefined,
    tracesSampleRate: SENTRY_BROWSER_TRACES_SAMPLE_RATE ?? undefined,
    integrations: [
      Sentry.browserTracingIntegration({
        beforeStartSpan: (options) => ({
          ...options,
          name: parameterizeTransactionName(options.name),
        }),
      }),
    ],
  });
}

export const SENTRY_ENABLED = !!SENTRY_DSN;
